<template>
  <div class="main-container">
    <!-- Navbar section -->
    <div class="content mt-4 section-space--ptb_120">
      <h1 class="text-center mb-4 ">mhp-finance.de</h1>
      <div class="container">

        <h2 class="text-center mb-20">Rechtliches</h2>

        <h6 class="text-green mt-20">Allgemeine Information über die Verarbeitung personenbezogener Daten</h6>
        Im Folgenden informieren wir über die Erhebung personenbezogener Daten bei Nutzung unseres Angebotes unter
        www.mhp-finance.de. Personenbezogene Daten sind alle Daten, die auf Sie persönlich beziehbar sind, z.B.
        Name, Adresse, E-Mail-Adressen, Nutzerverhalten.

        Verantwortlicher gem. Art. 4 Abs. 7 EU-Datenschutz-Grundverordnung (DSGVO) ist die [ORT EINFÜGEN]. Weitere
        Kontaktdaten, insbesondere die E-Mailadresse, können dem
        Impressum entnommen werden.

        Die Webseite verwendet ein Verschlüsselungsverfahren (z.B. SSL), um die Sicherheit Ihrer Daten bei
        Übertragungen zu schützen. So kann verhindert werden, dass übertragene Daten von Dritten mitgelesen werden.
        Sie erkennen die verschlüsselte Verbindung daran, dass die Adresszeile des Browsers mit “https://” anfängt und
        dem Schloss-Symbol davor.

        <h6 class="text-green mt-20">Ihre Rechte</h6>
        Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:

        <ul>
          <li>Recht auf Auskunft,</li>
          <li>Recht auf Berichtigung oder Löschung,</li>
          <li>Recht auf Einschränkung der Verarbeitung,</li>
          <li>Recht auf Widerspruch gegen die Verarbeitung,</li>
          <li>Recht auf Datenübertragbarkeit.</li>
        </ul>

        Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer
        personenbezogenen Daten durch uns zu beschweren.

        <h6 class="text-green mt-20">Verarbeitung personenbezogener Daten beim Besuch unserer Webseite</h6>
        Bei der bloß informatorischen Nutzung der Webseite, also wenn Sie uns nicht anderweitig Informationen
        übermitteln, erheben wir nur die personenbezogenen Daten, die Ihr Browser an unseren Server übermittelt. Wenn
        Sie unsere Webseite betrachten möchten, erheben wir die folgenden Daten, die für uns technisch erforderlich
        sind, um Ihnen unsere Webseite anzuzeigen und die Stabilität und Sicherheit zu gewährleisten, Rechtsgrundlage
        ist Art. 6 Abs. 1 S. 1 lit. f DSGVO:

        <ul>
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>Zeitzonendifferenz zur Greenwich Mean Time (GMT)</li>
          <li>Inhalt der Anforderung (konkrete Seite)</li>
          <li>Zugriffsstatus/HTTP-Statuscode</li>
          <li>jeweils übertragene Datenmenge</li>
          <li>Webseite, von der die Anforderung kommt</li>
          <li>Browser</li>
          <li>Betriebssystem und dessen Oberfläche</li>
          <li>Sprache und Version der Browsersoftware</li>
        </ul>

        <h6 class="text-green mt-20">Verarbeitung personenbezogener Daten bei Kontaktaufnahme durch Formular oder E-Mail
        </h6>
        Bei der Kontaktaufnahme mit uns per Kontaktformular oder E-Mail werden die von Ihnen mitgeteilten Daten (Name,
        E-Mail-Adresse, Telefonnummer, etc.) von uns gespeichert, um Ihre Nachricht bearbeiten und beantworten zu
        können. Sofern Sie uns eine E-Mail senden, verstehen wir dies als Einwilligung per E-Mail zu kommunizieren,
        obwohl E-Mails nur während der Versendung verschlüsselt sind und daher Dritte von deren Inhalt unberechtigt
        Kenntnis nehmen können. Sie können der Versendung unverschlüsselter E-Mails jederzeit widersprechen.
        Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des Nutzers entweder Art. 6
        Abs. 1 lit. a) DSGVO und bei der Zielsetzung eines Vertragsschlusses Art. 6 Abs. 1 lit. b) DSGVO. Nach
        Erreichung des Zwecks bzw. Beantwortung der Nachricht werden die Daten gelöscht.

        <h6 class="text-green mt-20">Verarbeitung personenbezogener Daten von Mitgliedern</h6>
        Für Eröffnung und Nutzung des Mitgliedskontos werden gem. Art. 6 Abs. 1 lit. b) DGSVO personenbezogene Daten
        verarbeitet, um den Login des Mitglieds zu ermöglichen. Dafür wird die vergebene 10-stellige Mitgliedsnummer mit
        dem Namen des Mitglieds, der dafür hinterlegten E-Mailadresse und dem generierten Passwort verknüpft. Diese
        Daten werden für den Login in den Mitgliederbereich während der gesamten Vertragslaufzeit gespeichert. Nach
        Vertragsende wird mit der Löschung des Mitgliedskontos auch die genannten mit dem Konto verknüpften Daten
        gelöscht.

        <h6 class="text-green mt-20">Verarbeitung personenbezogener Daten von Interessenten </h6>
        Wir geben bei Interesse an einer Sammlung Ihre dafür angegebenen personenbezogenen Daten (Name, E-Mail-Adresse,
        Telefonnummer, etc.) ausschließlich an Sammler und Eigentümer der Kunstsammlungen weiter, für die Sie sich
        interessieren. Rechtsgrundlage für diese Verarbeitung ist Ihre zuvor dafür erteilte Einwilligung nach Art. 6
        Abs. 1 lit. a) DSGVO. Eine Übermittlung Ihrer persönlichen Daten an weitere Personen oder zu einem anderen als
        den vorgenannten Zweck findet nicht statt.

        <h6 class="text-green mt-20">Widerruf und Widerspruch der Datenverarbeitung</h6>
        Falls Sie uns eine Einwilligung zur Verarbeitung Ihrer Daten gem. Art. 6 Abs. 1 lit. a) DSGVO erteilt haben,
        können Sie diese jederzeit mit Wirkung für die Zukunft widerrufen. Ein solcher Widerruf beeinflusst nur die
        Zulässigkeit der Verarbeitung Ihrer personenbezogenen Daten, nachdem Sie ihn gegenüber uns ausgesprochen haben.
        <br />
        Soweit wir die Verarbeitung Ihrer personenbezogenen Daten auf die Interessenabwägung gem. Art. 6 Abs. 1 lit. f)
        DSGVO oder die Wahrnehmung einer Aufgabe, die im öffentlichen Interesse liegt gem. Art. 6 Abs. 1 lit. e) DSGVO
        stützen, können Sie jederzeit Widerspruch gegen die Verarbeitung einlegen. Bei Ausübung eines solchen
        Widerspruchs bitten wir um Darlegung der Gründe, weshalb wir Ihre personenbezogenen Daten nicht wie von uns
        durchgeführt verarbeiten dürfen. Im Falle Ihres Widerspruchs prüfen wir diesen und werden die Datenverarbeitung
        entweder einstellen bzw. anpassen oder Ihnen unsere zwingenden schutzwürdigen Gründe nachweisen bzw. die
        Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen aufzeigen, aufgrund derer wir die Verarbeitung
        fortführen.
        <br />
        Werden personenbezogene Daten verarbeitet, um Direktwerbung zu betreiben, so haben Sie als betroffener Person
        das Recht, jederzeit Widerspruch gegen die Verarbeitung sie betreffender personenbezogener Daten zum Zwecke
        derartiger Werbung einzulegen. Nach Ihrem Widerspruch werden wir die personenbezogenen Daten nicht mehr für
        diese Zwecke verarbeiten.

        <h6 class="text-green mt-20">Verwendung von Cookies</h6>
        Diese Website nutzt verschiedene Cookies, deren Funktionsweise und Umfang im Folgenden erläutert werden:
        <br />
        Cookies sind kleine Textdateien, die auf Ihrem Computer gespeichert werden. Dazu zählen insbesondere die
        Session-Cookies. Diese speichern eine sogenannte Session-ID, mit welcher sich verschiedene Anfragen Ihres
        Browsers der gemeinsamen Sitzung zuordnen lassen. Dadurch kann Ihr Gerät wiedererkannt werden, wenn Sie auf
        unsere Website zurückkehren. Die Session-Cookies werden gelöscht, wenn Sie sich ausloggen oder den Browser
        schließen. Sog. persistente Cookies ermöglichen die Analyse der Zugriffe auf unsere Website und das
        Benutzerverhalten. Diese erheben und verarbeiten im individuellen Umfang bestimmte Informationen zum Nutzer
        unserer Seite wie Browser- und Standortdaten sowie IP-Adresswerte. Persistente Cookies werden automatisiert nach
        einer vorgegebenen Dauer gelöscht, die sich je nach Cookie unterscheiden kann.
        <br />
        Sie können die Cookies in den Sicherheitseinstellungen Ihres Browsers jederzeit löschen. Sie können Ihre
        Browser-Einstellung entsprechend Ihren Wünschen konfigurieren und z.B.  die Annahme von Third-Party-Cookies oder
        allen Cookies ablehnen. Wir weisen Sie darauf hin, dass Sie in diesem Fall nicht alle Funktionen dieser Website
        nutzen können.
        <br />
        Laut Gesetz können wir Cookies auf Ihrem Gerät speichern, wenn diese für den Betrieb dieser Seite unbedingt
        notwendig sind. Für alle anderen Cookie-Typen benötigen wir Ihre Erlaubnis.

        <h6 class="text-green mt-20">Dauer der Speicherung personenbezogener Daten
        </h6>

        Die Dauer der Speicherung von personenbezogenen Daten hängt bei den Verarbeitungsprozessen vom jeweiligen Zweck
        und gesetzlichen Aufbewahrungsfristen ab. Sofern eine Speicherung nicht mehr erforderlich ist, weil der Zweck
        erreicht worden ist, löschen wir die Daten regelmäßig, es sei denn, wir sind zur Aufbewahrung verpflichtet oder
        es bestehen berechtigte Interessen beispielsweise aufgrund von Beweiszwecken fort. Gesetzlichen
        Aufbewahrungsfristen können sich insbesondere aus dem Steuer- und Handelsrecht ergeben und zu einer Speicherung
        von bis zu 10 Jahren führen.
      </div>
    </div>

    <!-- footer section -->
    <FooterMain />
  </div>
</template>

<script>
import FooterMain from '@/components/FooterMain'

export default {
  name: 'DataProtection',
  components: {
    FooterMain
  }
}
</script>